import { isString } from './isString';

import { LOCALE } from '../constants';

export function upperCase(input, locale = LOCALE) {
  if (!isString(input)) return '';
  return input.toLocaleUpperCase(locale);
}
